var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('isHeader',{ref:"isHeader"}),_c('div',{ref:"scrollBox",staticStyle:{"height":"100vh","overflow-y":"auto","overflow-x":"hidden"}},[_c('commonTop',{attrs:{"info":{
        title: '新闻中心',
        desc: '关注华信互联，掌握行业最新动态',
        show_desc: true,
      },"img":require('@/assets/EcologicalRecruitment/banner1.png')}}),_c('NewsList',{on:{"scrollToTop":_vm.scrollToTop}}),_c('isFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }